import {Component, OnInit} from '@angular/core';
import {LeagueService} from '@core/services/league.service';
import {AppLeague} from '@shared/models/league';
import {TeamService} from '@core/services/team.service';
import {AppTeam} from '@shared/models/team';
import {AdCampaignService} from '@components/ad-campaign/services/ad-campaign.service';
import {AdCampaignPlacement} from '@api/models/ad-campaign/ad-campaign-placement';
import {EntityType} from '@lib/models/entity/entity-type';

@Component({
  selector: 'app-team-matches-wrapper',
  templateUrl: './team-matches-wrapper.component.html',
  styleUrls: [],
})

export class TeamMatchesWrapperComponent implements OnInit {

  public team: AppTeam = null;
  public league: AppLeague = null;
  public entityType = EntityType.Team;

  constructor( private leagueService: LeagueService,
               private teamService: TeamService,
               private adCampaignService: AdCampaignService ) { }

  ngOnInit(): void {
    this.adCampaignService.setPlacement(AdCampaignPlacement.Events);
    this.team = this.teamService.getCurrentTeam();
    this.leagueService.getLeague(this.team.getLeagueForTable()).then(league => {
      this.league = league;
    });
  }
}
